import React from 'react'
import { Clipboard, X, ArrowDownUp } from 'lucide-react'

/**
 * Content Dialog Component
 * Displays the template content in JSON format with copy functionality
 */
const ContentDialog = ({
  showContentDialog,
  setShowContentDialog,
  template_content,
  copyToClipboard,
  onRearrangeItems
}) => {
  if (!showContentDialog) {
    return null
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[550] p-4">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex-shrink-0 flex items-center justify-between p-6 pb-4 border-b border-gray-200">
          <h2 className="text-xl font-bold">Template Content</h2>
          <div className="flex items-center space-x-2">
            {onRearrangeItems && (
              <button
                onClick={onRearrangeItems}
                className="flex items-center space-x-2 bg-gray-100 text-gray-700 px-4 py-2 rounded hover:bg-gray-200 transition-colors"
                title="Sort each page's items array in ascending order of layer number"
              >
                <ArrowDownUp className="w-4 h-4" />
                <span>Re-arrange items</span>
              </button>
            )}
            <button
              onClick={copyToClipboard}
              className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
            >
              <Clipboard className="w-4 h-4" />
              <span>Copy</span>
            </button>
            <button
              onClick={() => setShowContentDialog(false)}
              className="p-2 hover:bg-gray-100 rounded"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <pre className="bg-gray-100 p-4 rounded text-sm">
            {JSON.stringify(template_content, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  )
}

export default ContentDialog
